<template>
  <!-- 顶部的路由面包屑 -->
  <div class="bread">
    <div class="example-container">
      <el-breadcrumb class="flex" separator="/">
        <el-breadcrumb-item
          v-for="(item, index) in breadList"
          :key="index"
          :to="{ path: item.path }"
          >{{ item.meta.title }}</el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      breadList: [] // 路由集合
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  methods: {
    isHome(route) {
      return route.meta.title === '网站首页'
    },
    getBreadcrumb() {
      let matched = this.$route.matched
      if (!this.isHome(matched[0])) {
        matched = [{ path: '/NavMenu', meta: { title: '首页' } }].concat(
          matched
        )
      }
      this.breadList = matched
    }
  },
  created() {
    this.getBreadcrumb()
  }
}
</script>
<style scoped>
.example-container {
  text-align: left;
  padding-left: 10px;
}
.bread /deep/ .el-breadcrumb {
  display: inline-block;
  display: inline-block;
  vertical-align: top;
  line-height: 50px;
  height: 50px;
}
.bread /deep/ .is-link {
  font-weight: normal;
}
/* .bread {
  float: left;
} */
</style>
